import React from 'react'
import { FormatISOToAZDate } from '../../helpers/formatting'

export default function CreatedUpdated(props) {
  const {
    createdAt,
    createdBy,
    updatedAt,
    updatedBy,
  } = props;

  return (
    <div className="columns is-multiline">
      <div className="level-item has-text-left is-2 p-3">
        <div className="has-text-grey is-size-7">
          <p>Created By:</p>
          <a href="/" className="has-text-link">{createdBy}</a>
          <p title={FormatISOToAZDate(createdAt, "MM/dd/yyyy hh:mm:ss a")}>{FormatISOToAZDate(createdAt)}</p>
        </div>
      </div>
      {updatedAt && (
        <div className="level-item has-text-left is-2 p-3">
          <div className="has-text-grey is-size-7">
            <p>Modified By:</p>
            <a href="/" className="has-text-link">{updatedBy}</a>
            <p title={FormatISOToAZDate(updatedAt, "MM/dd/yyyy hh:mm:ss a")}>{FormatISOToAZDate(updatedAt)}</p>
          </div>
        </div>
      )}
    </div>
  )
}
